module.exports = __webpack_public_path__ + "static/media/building5.676963e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/shared/building5.png
// module id = 72
// module chunks = 0